import DOMPurify from "dompurify"; // eslint-disable-line import-x/no-named-as-default -- DOMPurify exposes its runtime implementation as a default export.

export const htmlSanitizer = (htmlString?: string): string => {
  if (!htmlString?.length) return "";

  return DOMPurify.sanitize(htmlString, { USE_PROFILES: { html: true } });
};
